import React from 'react';

import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

import AdminUpdateUserModal from './AdminUpdateUserModal';
import AdminDeleteUserModal from './AdminDeleteUserModal';
import AdminInviteUserModal from './AdminInviteUserModal';

class AdminUserRow extends React.Component {
    constructor(props) {
	super(props);
	
	this.state = {
	    showUpdateUser: false,
	    showDeleteUser: false,
	    showInviteUser: false
	};

	this.handleSuccess = this.handleSuccess.bind(this);
	this.handleError = this.handleError.bind(this);
    }

    handleSuccess() {
	this.setState({
	    showUpdateUser: false,
	    showDeleteUser: false,
	    showInviteUser: false
	});

	this.props.onSuccess();
    }
    
    handleError() {
	this.setState({
	    showUpdateUser: false,
	    showDeleteUser: false,
	    showInviteUser: false
	});

	this.props.onError();
    }
    
    render() {
	var user = this.props.user;

	var status = "";
	var level = "";

	switch (user.status) {
	case 1:
	case "1":
	    status = "Tillagd";
	    break;
	case 2:
	case "2":
	    status = "Beg&auml;rd";
	    break;
	case 3:
	case "3":
	    status = "Inbjuden";
	    break;
	case 4:
	case "4":
	    status = "Accepterad";
	    break;
	default:
	    status = "Odefinierad";
	    break;
	}

	switch (user.level) {
	case 1:
	case "1":
	    level = "Admin";
	    break;
	case 5:
	case "5":
	    level = "Kursteam";
	    break;
	case 10:
	case "10":
	    level = "Alumni";
	    break;
	case 99:
	case "99":
	    level = "G&auml;st";
	    break;
	default:
	    level = "Odefinierad";
	    break;
	}
	
	return (
	    <>
		<tr>
		    <td>{user.firstname} {user.lastname}</td>
		    <td>{user.year}</td>
		    <td>{user.troop}</td>
		    <td>{user.email}</td>
		    <td>{level}</td>
		    <td>{status}</td>
		    <td>{user.active?"Ja":"Nej"}</td>
		    <td>
			<OverlayTrigger overlay={<Tooltip>Uppdatera {user.firstname} {user.lastname}</Tooltip>}>
			    <img src="edit_user.png" alt="Uppdatera" className="pointer" onClick={() => this.setState({showUpdateUser: true})} />
			</OverlayTrigger>
			<OverlayTrigger overlay={<Tooltip>Radera {user.firstname} {user.lastname}</Tooltip>}>
			    <img src="remove_user.png" alt="Radera" className="pointer" onClick={() => this.setState({showDeleteUser: true})} />
			</OverlayTrigger>
			<OverlayTrigger overlay={<Tooltip>Bjud in {user.firstname} {user.lastname}</Tooltip>}>
			    <img src="send.png" alt="Bjud in" className="pointer" onClick={() => this.setState({showInviteUser: true})} />
			</OverlayTrigger>
		    </td>
		</tr>
		
		<AdminUpdateUserModal show={this.state.showUpdateUser}
				      user={user}
				      token={this.props.token}
				      onHide={() => this.setState({showUpdateUser: false})}
				      onSuccess={this.handleSuccess}
				      onError={this.handleError}
				      onAuthError={this.props.onAuthError}
		/>
		
		<AdminDeleteUserModal show={this.state.showDeleteUser}
				      user={user}
				      token={this.props.token}
				      onHide={() => this.setState({showDeleteUser: false})}
				      onSuccess={this.handleSuccess}
				      onError={this.handleError}
				      onAuthError={this.props.onAuthError}
		/>
		
		<AdminInviteUserModal show={this.state.showInviteUser}
				      user={user}
				      token={this.props.token}
				      onHide={() => this.setState({showInviteUser: false})}
				      onSuccess={this.handleSuccess}
				      onError={this.handleError}
				      onAuthError={this.props.onAuthError}
		/>
	    </>
	);
    }
}

export default AdminUserRow;
